/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import ImageUpload from "./ImageUpload";
import html2canvas from "html2canvas";

// Function to return HTML block 1
const Block1 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  // console.log(addToCartTriggered)
  const [selectedImages, setSelectedImages] = useState(Array(4).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  const [ShowCropIcon, setShowCropIcon] = useState(false)
  const [EnableCroping, setEnableCroping] = useState(false)
  const [ResetZoom, setResetZoom] = useState(false)

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    // console.log(BlobImage)
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;

      const allImagesSelected = newImages.every((image) => image !== ""); 
    if (allImagesSelected) {
      setShowCropIcon(true);
    } 

      return newImages;
    });
 
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");

    // const htmlContent1 = captureArea.outerHTML;
    // console.log(htmlContent1)

    html2canvas(captureArea).then(function (canvas) {
      // Convert the canvas content to a data URL representing the image
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        // console.log(blob);
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
      // console.log(imageDataUrl);
      // Open a new window/tab with the captured image
      // const newWindow = window.open();
      // newWindow.document.write(
      //   '<img src="' + imageDataUrl + '" alt="Captured Screenshot">'
      // );
    });
  };

  return (
    <div className="large-bg collage-1 g-w-1">
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
          <div className="number-line">
            {/* <span>24"</span> */}
          </div>
          <div className="d-flex" id="captureArea">
            <div className="frame-left">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/frame-16-12.svg"
                className="firstframe_16x24"
                onChange={(e) => {
                  handleImageChange(e, 0);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/frame-1-17-11.svg"
                className="firstframe_17x11"
                onChange={(e) => {
                  handleImageChange(e, 1);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <div className="class=frame-right-child d-flex">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/frame-1-8-12.svg"
                  className="firstframe_8x12"
                  onChange={(e) => {
                    handleImageChange(e, 2);
                  }}
                  CropEnable={EnableCroping}
                  resetzoom={ResetZoom}
                />
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/frame-1-8-12.svg"
                  className="firstframe_8x12"
                  onChange={(e) => {
                    handleImageChange(e, 3);
                  }}
                  CropEnable={EnableCroping}
                  resetzoom={ResetZoom}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="number-line-2">
          {/* <span>34"</span> */}

          {ShowCropIcon && !EnableCroping && <div className="d-flex justify-content-between mt-3">
               <button className="mx-5 btn btn-sm btn-secondary" onClick={()=>{setEnableCroping(true);setResetZoom(false)}}>Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan <i class="fa fa-crop pointer" aria-hidden="true"></i></button>
            {/* <label className="mx-5 pointer">Reset</label> */}
            </div>}
            {EnableCroping && 
            <div className="d-flex justify-content-between mt-3">
              <div>
            <label className="mx-5 fw-bold align-items-baseline d-flex"> Crop <h6 className="fw-normal text-muted ms-4">Scroll to zomm and Drag to pan</h6></label>
              </div>
              <div className="mx-5">
         <button className="me-3 btn-sm btn btn-outline-dark" onClick={()=>{setEnableCroping(false);setResetZoom(true)}} >Reset</button>
         <button className="btn btn-secondary btn-sm" onClick={()=>setEnableCroping(false)}>Apply</button>
              </div>
         </div>}
        </div>
      </div>
    </div>
  );
};

// Function to return HTML block 2
const Block2 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  const [selectedImages, setSelectedImages] = useState(Array(4).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  const [ShowCropIcon, setShowCropIcon] = useState(false)
  const [EnableCroping, setEnableCroping] = useState(false)
  const [ResetZoom, setResetZoom] = useState(false)

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    // console.log(BlobImage)
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;

      const allImagesSelected = newImages.every((image) => image !== ""); 
      if (allImagesSelected) {
        setShowCropIcon(true);
      } 

      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");

    // const htmlContent1 = captureArea.outerHTML;
    // console.log(htmlContent1)

    html2canvas(captureArea).then(function (canvas) {
      // Convert the canvas content to a data URL representing the image
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        // console.log(blob);
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
      // console.log(imageDataUrl);
      // Open a new window/tab with the captured image
      // const newWindow = window.open();
      // newWindow.document.write(
      //   '<img src="' + imageDataUrl + '" alt="Captured Screenshot">'
      // );
    });
  };

  return (
    <div className="large-bg collage-2 g-w-2">
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
          <div className="number-line">
            {/* <span>32"</span> */}
          </div>

          <div className="d-flex" id="captureArea">
            <div className="frame-left">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/freame-2-20-32.svg"
                className="secondframe_20x32"
                onChange={(e) => {
                  handleImageChange(e, 0);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/frame-2-13-10.svg"
                className="secondframe_13x10"
                onChange={(e) => {
                  handleImageChange(e, 1);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/frame-2-13-10.svg"
                className="secondframe_13x10"
                onChange={(e) => {
                  handleImageChange(e, 2);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/frame-2-13-10.svg"
                className="secondframe_13x10"
                onChange={(e) => {
                  handleImageChange(e, 3);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
          </div>
        </div>
        <div className="number-line-2">
          {/* <span>34"</span> */}

          {ShowCropIcon && !EnableCroping && <div className="d-flex justify-content-between mt-3">
               <button className="mx-5 btn btn-sm btn-secondary" onClick={()=>{setEnableCroping(true);setResetZoom(false)}}>Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan <i class="fa fa-crop pointer" aria-hidden="true"></i></button>
            {/* <label className="mx-5 pointer">Reset</label> */}
            </div>}
            {EnableCroping && 
            <div className="d-flex justify-content-between mt-3">
              <div>
            <label className="mx-5 fw-bold align-items-baseline d-flex"> Crop <h6 className="fw-normal text-muted ms-4">Scroll to zomm and Drag to pan</h6></label>
              </div>
              <div className="mx-5">
         <button className="me-3 btn-sm btn btn-outline-dark" onClick={()=>{setEnableCroping(false);setResetZoom(true)}} >Reset</button>
         <button className="btn btn-secondary btn-sm" onClick={()=>setEnableCroping(false)}>Apply</button>
              </div>
         </div>}
        </div>
      </div>
    </div>
  );
};

const Block3 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  const [selectedImages, setSelectedImages] = useState(Array(5).fill(""));

  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  const [ShowCropIcon, setShowCropIcon] = useState(false)
  const [EnableCroping, setEnableCroping] = useState(false)
  const [ResetZoom, setResetZoom] = useState(false)

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    // console.log(BlobImage)
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;

      const allImagesSelected = newImages.every((image) => image !== ""); 
      if (allImagesSelected) {
        setShowCropIcon(true);
      } 
  
      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");

    // const htmlContent1 = captureArea.outerHTML;
    // console.log(htmlContent1)

    html2canvas(captureArea).then(function (canvas) {
      // Convert the canvas content to a data URL representing the image
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        console.log(blob);
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      console.log(imageDataUrl);
      setFullImageDataURL(imageDataUrl);
      // console.log(imageDataUrl);
      // Open a new window/tab with the captured image
      // const newWindow = window.open();
      // newWindow.document.write(
      //   '<img src="' + imageDataUrl + '" alt="Captured Screenshot">'
      // );
    });
  };

  return (
    <div className="large-bg collage-3 g-w-3">
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
          <div className="number-line">
            {/* <span>40"</span> */}
          </div>

          <div className="d-flex align-items-center" id="captureArea">
            <div className="frame-left">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/thirdframe-16-20.svg"
                className="thirdframe-16-20"
                onChange={(e) => {
                  handleImageChange(e, 0);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/thirdframe-14-14.svg"
                className="thirdframe-14-14"
                onChange={(e) => {
                  handleImageChange(e, 1);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />

              <div className="d-flex">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/thirdframe-20-10.svg"
                  className="thirdframe-20-10"
                  onChange={(e) => {
                    handleImageChange(e, 2);
                  }}
                  CropEnable={EnableCroping}
                  resetzoom={ResetZoom}
                />
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/thirdframe-10-10.svg"
                  className="thirdframe-10-10"
                  onChange={(e) => {
                    handleImageChange(e, 3);
                  }}
                  CropEnable={EnableCroping}
                  resetzoom={ResetZoom}
                />
              </div>
              <ImageUpload
                defaultImage="assets/img/breadcrumb/thirdframe-10-14.svg"
                className="thirdframe-10-14"
                onChange={(e) => {
                  handleImageChange(e, 4);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
          </div>
        </div>
        <div className="number-line-2">
          {/* <span>48"</span> */}

          {ShowCropIcon && !EnableCroping && <div className="d-flex justify-content-between mt-3">
               <button className="mx-5 btn btn-sm btn-secondary" onClick={()=>{setEnableCroping(true);setResetZoom(false)}}>Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan <i class="fa fa-crop pointer" aria-hidden="true"></i></button>
            {/* <label className="mx-5 pointer">Reset</label> */}
            </div>}
            {EnableCroping && 
            <div className="d-flex justify-content-between mt-3">
              <div>
            <label className="mx-5 fw-bold align-items-baseline d-flex"> Crop <h6 className="fw-normal text-muted ms-4">Scroll to zomm and Drag to pan</h6></label>
              </div>
              <div className="mx-5">
         <button className="me-3 btn-sm btn btn-outline-dark" onClick={()=>{setEnableCroping(false);setResetZoom(true)}} >Reset</button>
         <button className="btn btn-secondary btn-sm" onClick={()=>setEnableCroping(false)}>Apply</button>
              </div>
         </div>}
        </div>
      </div>
    </div>
  );
};

const Block4 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  const [selectedImages, setSelectedImages] = useState(Array(5).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  const [ShowCropIcon, setShowCropIcon] = useState(false)
  const [EnableCroping, setEnableCroping] = useState(false)
  const [ResetZoom, setResetZoom] = useState(false)

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    // console.log(BlobImage)
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      
      const allImagesSelected = newImages.every((image) => image !== ""); 
    if (allImagesSelected) {
      setShowCropIcon(true);
    } 

      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");

    // const htmlContent1 = captureArea.outerHTML;
    // console.log(htmlContent1)

    html2canvas(captureArea).then(function (canvas) {
      // Convert the canvas content to a data URL representing the image
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        // console.log(blob);
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
      // console.log(imageDataUrl);
      // Open a new window/tab with the captured image
      // const newWindow = window.open();
      // newWindow.document.write(
      //   '<img src="' + imageDataUrl + '" alt="Captured Screenshot">'
      // );
    });
  };

  return (
    <div className="large-bg collage-4 g-w-4">
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
          <div className="number-line">
            {/* <span>44"</span> */}
          </div>

          <div className="d-flex" id="captureArea">
            <div className="frame-right">
              <div style={{ opacity: 0, height: "157px" }}>
                {/* <ImageUpload
                  defaultImage="assets/img/breadcrumb/fourth-14-11.svg"
                  className="secondframe_13x10" 
                /> */}
              </div>
              {/* <div className="control-group file-upload" style={{opacity: 0}}>
      <div className="image-box"><img src="assets/img/breadcrumb/fourth-14-11.svg" alt className="secondframe_13x10" /></div>
      <div className="controls" style={{display: 'none'}}><input type="file" style={{display: 'none'}} /></div>
    </div>*/}

              <ImageUpload
                defaultImage="assets/img/breadcrumb/fourth-14-11.svg"
                className="secondframe_13x10"
                onChange={(e) => {
                  handleImageChange(e, 0);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/fourth-14-11.svg"
                className="secondframe_13x10"
                onChange={(e) => {
                  handleImageChange(e, 1);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-left">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/fourth-16-20.svg"
                className="secondframe_20x32 piece"
                onChange={(e) => {
                  handleImageChange(e, 2);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/fourth-14-11.svg"
                className="secondframe_13x10"
                onChange={(e) => {
                  handleImageChange(e, 3);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/fourth-14-11.svg"
                className="secondframe_13x10"
                onChange={(e) => {
                  handleImageChange(e, 4);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
          </div>
        </div>
        <div className="number-line-2">
          {/* <span>50"</span> */}
          {ShowCropIcon && !EnableCroping && <div className="d-flex justify-content-between mt-3">
               <button className="mx-5 btn btn-sm btn-secondary" onClick={()=>{setEnableCroping(true);setResetZoom(false)}}>Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan <i class="fa fa-crop pointer" aria-hidden="true"></i></button>
            {/* <label className="mx-5 pointer">Reset</label> */}
            </div>}
            {EnableCroping && 
            <div className="d-flex justify-content-between mt-3">
              <div>
            <label className="mx-5 fw-bold align-items-baseline d-flex"> Crop <h6 className="fw-normal text-muted ms-4">Scroll to zomm and Drag to pan</h6></label>
              </div>
              <div className="mx-5">
         <button className="me-3 btn-sm btn btn-outline-dark" onClick={()=>{setEnableCroping(false);setResetZoom(true)}} >Reset</button>
         <button className="btn btn-secondary btn-sm" onClick={()=>setEnableCroping(false)}>Apply</button>
              </div>
         </div>}
        </div>
      </div>
    </div>
  );
};

const Block5 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  const [selectedImages, setSelectedImages] = useState(Array(6).fill(""));

  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");

  const [ShowCropIcon, setShowCropIcon] = useState(false)
  const [EnableCroping, setEnableCroping] = useState(false)
  const [ResetZoom, setResetZoom] = useState(false)

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    // console.log(BlobImage)
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      
      const allImagesSelected = newImages.every((image) => image !== ""); 
    if (allImagesSelected) {
      setShowCropIcon(true);
    } 

      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");

    // const htmlContent1 = captureArea.outerHTML;
    // console.log(htmlContent1)

    html2canvas(captureArea).then(function (canvas) {
      // Convert the canvas content to a data URL representing the image
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        // console.log(blob);
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
      // console.log(imageDataUrl);
      // Open a new window/tab with the captured image
      // const newWindow = window.open();
      // newWindow.document.write(
      //   '<img src="' + imageDataUrl + '" alt="Captured Screenshot">'
      // );
    });
  };

  return (
    <div className="large-bg collage-6 g-w-5">
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
          <div className="number-line">
            {/* <span>44"</span> */}
          </div>

          <div className="d-flex r" id="captureArea">
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/six-14-11.svg"
                className="six-14-11"
                onChange={(e) => {
                  handleImageChange(e, 0);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-left">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/six-32-30.svg"
                className="six-32-30"
                onChange={(e) => {
                  handleImageChange(e, 1);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />

              <div className="frame-right d-flex">
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/six-8-8.svg"
                  className="six-8-8"
                  onChange={(e) => {
                    handleImageChange(e, 2);
                  }}
                  CropEnable={EnableCroping}
                  resetzoom={ResetZoom}
                />
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/six-8-8.svg"
                  className="six-8-8"
                  onChange={(e) => {
                    handleImageChange(e, 3);
                  }}
                  CropEnable={EnableCroping}
                  resetzoom={ResetZoom}
                />
                <ImageUpload
                  defaultImage="assets/img/breadcrumb/six-8-8.svg"
                  className="six-8-8"
                  onChange={(e) => {
                    handleImageChange(e, 4);
                  }}
                  CropEnable={EnableCroping}
                  resetzoom={ResetZoom}
                />
              </div>
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/six-14-11.svg"
                className="six-14-11"
                onChange={(e) => {
                  handleImageChange(e, 5);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
          </div>
        </div>
        <div className="number-line-2">
          {/* <span>56"</span> */}
          {ShowCropIcon && !EnableCroping && <div className="d-flex justify-content-between mt-3">
               <button className="mx-5 btn btn-sm btn-secondary" onClick={()=>{setEnableCroping(true);setResetZoom(false)}}>Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan <i class="fa fa-crop pointer" aria-hidden="true"></i></button>
            {/* <label className="mx-5 pointer">Reset</label> */}
            </div>}
            {EnableCroping && 
            <div className="d-flex justify-content-between mt-3">
              <div>
            <label className="mx-5 fw-bold align-items-baseline d-flex"> Crop <h6 className="fw-normal text-muted ms-4">Scroll to zomm and Drag to pan</h6></label>
              </div>
              <div className="mx-5">
         <button className="me-3 btn-sm btn btn-outline-dark" onClick={()=>{setEnableCroping(false);setResetZoom(true)}} >Reset</button>
         <button className="btn btn-secondary btn-sm" onClick={()=>setEnableCroping(false)}>Apply</button>
              </div>
         </div>}
        </div>
      </div>
    </div>
  );
};

const Block6 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  const [selectedImages, setSelectedImages] = useState(Array(6).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");
  const [ShowCropIcon, setShowCropIcon] = useState(false)
  const [EnableCroping, setEnableCroping] = useState(false)
  const [ResetZoom, setResetZoom] = useState(false)

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    // console.log(BlobImage)
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      
      const allImagesSelected = newImages.every((image) => image !== ""); 
    if (allImagesSelected) {
      setShowCropIcon(true);
    } 

      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");

    // const htmlContent1 = captureArea.outerHTML;
    // console.log(htmlContent1)

    html2canvas(captureArea).then(function (canvas) {
      // Convert the canvas content to a data URL representing the image
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        // console.log(blob);
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
      // console.log(imageDataUrl);
      // Open a new window/tab with the captured image
      // const newWindow = window.open();
      // newWindow.document.write(
      //   '<img src="' + imageDataUrl + '" alt="Captured Screenshot">'
      // );
    });
  };

  return (
    <div className="large-bg collage-5 g-w-6">
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
          <div className="number-line">
            {/* <span>28"</span> */}
          </div>

          <div className="d-flex align-items-center" id="captureArea">
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/five-10-10.svg"
                className="five-10-10"
                onChange={(e) => {
                  handleImageChange(e, 0);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-left">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/five-16-20.svg"
                className="five-16-20"
                onChange={(e) => {
                  handleImageChange(e, 1);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/five-16-20-large.svg"
                className="five-16-20-large"
                onChange={(e) => {
                  handleImageChange(e, 2);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/five-16-11.svg"
                className="five-16-11"
                onChange={(e) => {
                  handleImageChange(e, 3);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/five-16-11.svg"
                className="five-16-11"
                onChange={(e) => {
                  handleImageChange(e, 4);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/five-12-10.svg"
                className="five-12-10"
                onChange={(e) => {
                  handleImageChange(e, 5);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
          </div>
        </div>
        <div className="number-line-2">
          {/* <span>68"</span> */}
          {ShowCropIcon && !EnableCroping && <div className="d-flex justify-content-between mt-3">
               <button className="mx-5 btn btn-sm btn-secondary" onClick={()=>{setEnableCroping(true);setResetZoom(false)}}>Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan <i class="fa fa-crop pointer" aria-hidden="true"></i></button>
            {/* <label className="mx-5 pointer">Reset</label> */}
            </div>}
            {EnableCroping && 
            <div className="d-flex justify-content-between mt-3">
              <div>
            <label className="mx-5 fw-bold align-items-baseline d-flex"> Crop <h6 className="fw-normal text-muted ms-4">Scroll to zomm and Drag to pan</h6></label>
              </div>
              <div className="mx-5">
         <button className="me-3 btn-sm btn btn-outline-dark" onClick={()=>{setEnableCroping(false);setResetZoom(true)}} >Reset</button>
         <button className="btn btn-secondary btn-sm" onClick={()=>setEnableCroping(false)}>Apply</button>
              </div>
         </div>}
        </div>
      </div>
    </div>
  );
};

const Block7 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  const [selectedImages, setSelectedImages] = useState(Array(7).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");
  const [ShowCropIcon, setShowCropIcon] = useState(false)
  const [EnableCroping, setEnableCroping] = useState(false)
  const [ResetZoom, setResetZoom] = useState(false)

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    // console.log(BlobImage)
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      
      const allImagesSelected = newImages.every((image) => image !== ""); 
    if (allImagesSelected) {
      setShowCropIcon(true);
    } 

      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");

    // const htmlContent1 = captureArea.outerHTML;
    // console.log(htmlContent1)

    html2canvas(captureArea).then(function (canvas) {
      // Convert the canvas content to a data URL representing the image
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        // console.log(blob);
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
      // console.log(imageDataUrl);
      // Open a new window/tab with the captured image
      // const newWindow = window.open();
      // newWindow.document.write(
      //   '<img src="' + imageDataUrl + '" alt="Captured Screenshot">'
      // );
    });
  };

  return (
    <div className="large-bg collage-5 g-w-7">
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
          <div className="number-line">
            {/* <span>38"</span> */}
          </div>

          <div className="d-flex align-items-center" id="captureArea">
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/nine-8-10.svg"
                className="nine-8-10"
                onChange={(e) => {
                  handleImageChange(e, 0);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/nine-10-10-10.svg"
                className="nine-10-10-10"
                onChange={(e) => {
                  handleImageChange(e, 1);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/nine-10-10-10.svg"
                className="nine-10-10-10"
                onChange={(e) => {
                  handleImageChange(e, 2);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/nine-8-16.svg"
                className="nine-8-16"
                onChange={(e) => {
                  handleImageChange(e, 3);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/nine-10-10-10.svg"
                className="nine-10-10-10"
                onChange={(e) => {
                  handleImageChange(e, 4);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/nine-10-10-10.svg"
                className="nine-10-10-10"
                onChange={(e) => {
                  handleImageChange(e, 5);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/nine-8-10.svg"
                className="nine-8-10"
                onChange={(e) => {
                  handleImageChange(e, 6);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
          </div>
        </div>
        <div className="number-line-2">
          {/* <span>30"</span> */}
          {ShowCropIcon && !EnableCroping && <div className="d-flex justify-content-between mt-3">
               <button className="mx-5 btn btn-sm btn-secondary" onClick={()=>{setEnableCroping(true);setResetZoom(false)}}>Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan <i class="fa fa-crop pointer" aria-hidden="true"></i></button>
            {/* <label className="mx-5 pointer">Reset</label> */}
            </div>}
            {EnableCroping && 
            <div className="d-flex justify-content-between mt-3">
              <div>
            <label className="mx-5 fw-bold align-items-baseline d-flex"> Crop <h6 className="fw-normal text-muted ms-4">Scroll to zomm and Drag to pan</h6></label>
              </div>
              <div className="mx-5">
         <button className="me-3 btn-sm btn btn-outline-dark" onClick={()=>{setEnableCroping(false);setResetZoom(true)}} >Reset</button>
         <button className="btn btn-secondary btn-sm" onClick={()=>setEnableCroping(false)}>Apply</button>
              </div>
         </div>}
        </div>
      </div>
    </div>
  );
};

const Block8 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  const [selectedImages, setSelectedImages] = useState(Array(7).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");
  const [ShowCropIcon, setShowCropIcon] = useState(false)
  const [EnableCroping, setEnableCroping] = useState(false)
  const [ResetZoom, setResetZoom] = useState(false)

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    // console.log(BlobImage)
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      
      const allImagesSelected = newImages.every((image) => image !== ""); 
    if (allImagesSelected) {
      setShowCropIcon(true);
    } 

      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");

    // const htmlContent1 = captureArea.outerHTML;
    // console.log(htmlContent1)

    html2canvas(captureArea).then(function (canvas) {
      // Convert the canvas content to a data URL representing the image
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        // console.log(blob);
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
      // console.log(imageDataUrl);
      // Open a new window/tab with the captured image
      // const newWindow = window.open();
      // newWindow.document.write(
      //   '<img src="' + imageDataUrl + '" alt="Captured Screenshot">'
      // );
    });
  };

  return (
    <div className="large-bg collage-5 g-w-8">
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4 third-last">
          <div className="number-line">
            {/* <span>26"</span> */}
          </div>

          <div className="d-flex align-items-center" id="captureArea">
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 0);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 1);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 2);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-26-26.svg"
                className="ten-26-26"
                onChange={(e) => {
                  handleImageChange(e, 3);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 4);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 5);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 6);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
          </div>
        </div>
        <div className="number-line-2">
          {/* <span>44"</span> */}
          {ShowCropIcon && !EnableCroping && <div className="d-flex justify-content-between mt-3">
               <button className="mx-5 btn btn-sm btn-secondary" onClick={()=>{setEnableCroping(true);setResetZoom(false)}}>Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan <i class="fa fa-crop pointer" aria-hidden="true"></i></button>
            {/* <label className="mx-5 pointer">Reset</label> */}
            </div>}
            {EnableCroping && 
            <div className="d-flex justify-content-between mt-3">
              <div>
            <label className="mx-5 fw-bold align-items-baseline d-flex"> Crop <h6 className="fw-normal text-muted ms-4">Scroll to zomm and Drag to pan</h6></label>
              </div>
              <div className="mx-5">
         <button className="me-3 btn-sm btn btn-outline-dark" onClick={()=>{setEnableCroping(false);setResetZoom(true)}} >Reset</button>
         <button className="btn btn-secondary btn-sm" onClick={()=>setEnableCroping(false)}>Apply</button>
              </div>
         </div>}
        </div>
      </div>
    </div>
  );
};

const Block9 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  const [selectedImages, setSelectedImages] = useState(Array(9).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");
  const [ShowCropIcon, setShowCropIcon] = useState(false)
  const [EnableCroping, setEnableCroping] = useState(false)
  const [ResetZoom, setResetZoom] = useState(false)

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    // console.log(BlobImage)
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      
      const allImagesSelected = newImages.every((image) => image !== ""); 
    if (allImagesSelected) {
      setShowCropIcon(true);
    } 

      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");

    // const htmlContent1 = captureArea.outerHTML;
    // console.log(htmlContent1)

    html2canvas(captureArea).then(function (canvas) {
      // Convert the canvas content to a data URL representing the image
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        // console.log(blob);
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
      // console.log(imageDataUrl);
      // Open a new window/tab with the captured image
      // const newWindow = window.open();
      // newWindow.document.write(
      //   '<img src="' + imageDataUrl + '" alt="Captured Screenshot">'
      // );
    });
  };

  return (
    <div className="large-bg collage-5 g-w-9">
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4 second-last">
          <div className="number-line">
            {/* <span>26"</span> */}
          </div>

          <div className="d-flex align-items-center" id="captureArea">
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 0);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 1);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 2);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 3);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 4);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 5);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 6);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 7);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/ten-8.8.svg"
                className="ten-8-8"
                onChange={(e) => {
                  handleImageChange(e, 8);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
          </div>
        </div>
        <div className="number-line-2">
          {/* <span>26"</span> */}
          {ShowCropIcon && !EnableCroping && <div className="d-flex justify-content-between mt-3">
               <button className="mx-5 btn btn-sm btn-secondary" onClick={()=>{setEnableCroping(true);setResetZoom(false)}}>Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan <i class="fa fa-crop pointer" aria-hidden="true"></i></button>
            {/* <label className="mx-5 pointer">Reset</label> */}
            </div>}
            {EnableCroping && 
            <div className="d-flex justify-content-between mt-3">
              <div>
            <label className="mx-5 fw-bold align-items-baseline d-flex"> Crop <h6 className="fw-normal text-muted ms-4">Scroll to zomm and Drag to pan</h6></label>
              </div>
              <div className="mx-5">
         <button className="me-3 btn-sm btn btn-outline-dark" onClick={()=>{setEnableCroping(false);setResetZoom(true)}} >Reset</button>
         <button className="btn btn-secondary btn-sm" onClick={()=>setEnableCroping(false)}>Apply</button>
              </div>
         </div>}
        </div>
      </div>
    </div>
  );
};

const Block10 = ({
  updateAllSelectedImages,
  addToCartTriggered,
  sendBlobImage,
}) => {
  const [selectedImages, setSelectedImages] = useState(Array(10).fill(""));
  const [BlobImage, setBlobImage] = useState("");
  const [FullImageDataURL, setFullImageDataURL] = useState("");
  const [ShowCropIcon, setShowCropIcon] = useState(false)
  const [EnableCroping, setEnableCroping] = useState(false)
  const [ResetZoom, setResetZoom] = useState(false)

  useEffect(() => {
    // console.log(addToCartTriggered)
    if (addToCartTriggered) {
      // console.log(addToCartTriggered)
      capture();
      // updateAllSelectedImages(selectedImages)
    }
  }, [addToCartTriggered]);

  useEffect(() => {
    updateAllSelectedImages(selectedImages);
  }, [selectedImages]);

  useEffect(() => {
    if (BlobImage) {
      sendBlobImage(BlobImage);
    }
  }, [BlobImage]);

  const handleImageChange = (imagePreview, index) => {
    setSelectedImages((prevImages) => {
      const newImages = [...prevImages];
      newImages[index] = imagePreview;
      
      const allImagesSelected = newImages.every((image) => image !== ""); 
    if (allImagesSelected) {
      setShowCropIcon(true);
    } 

      return newImages;
    });
  };

  const capture = () => {
    const captureArea = document.getElementById("captureArea");

    // const htmlContent1 = captureArea.outerHTML;
    // console.log(htmlContent1)

    html2canvas(captureArea).then(function (canvas) {
      const imageDataUrlforBlob = canvas.toBlob((blob) => {
        // console.log(blob);
        setBlobImage(blob);
      });
      const imageDataUrl = canvas.toDataURL("image/png");
      setFullImageDataURL(imageDataUrl);
    });
  };

  return (
    <div className="large-bg collage-8 g-w-10">
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center mt-4">
          <div className="number-line">
            {/* <span>45"</span> */}
          </div>
          <div className="d-flex align-items-end" id="captureArea">
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/image-12-16-size.svg"
                className="image-12-16-size"
                onChange={(e) => {
                  handleImageChange(e, 0);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/five-16-11.svg"
                className="five-16-11"
                onChange={(e) => {
                  handleImageChange(e, 1);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
              <ImageUpload
                defaultImage="assets/img/breadcrumb/five-16-11.svg"
                className="five-16-11"
                onChange={(e) => {
                  handleImageChange(e, 2);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/five-16-20-large.svg"
                className="five-16-20-large"
                onChange={(e) => {
                  handleImageChange(e, 3);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-left">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/five-16-20.svg"
                className="five-16-20"
                onChange={(e) => {
                  handleImageChange(e, 4);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/five-12-10.svg"
                className="five-12-10-large"
                onChange={(e) => {
                  handleImageChange(e, 5);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-lg-6 col-md-12 m-auto d-flex justify-content-center">
          <div className="d-flex align-items-start" id="captureArea">
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/f16-11-bt-row-1.svg"
                className="f16-11-bt-row-1"
                onChange={(e) => {
                  handleImageChange(e, 6);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/f16-11-bt-row-2.svg"
                className="f16-11-bt-row-2"
                onChange={(e) => {
                  handleImageChange(e, 7);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-right">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/f16-11-bt-row-3.svg"
                className="f16-11-bt-row-3"
                onChange={(e) => {
                  handleImageChange(e, 8);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
            <div className="frame-left">
              <ImageUpload
                defaultImage="assets/img/breadcrumb/f16-11-bt-row-4.svg"
                className="f16-11-bt-row-4"
                onChange={(e) => {
                  handleImageChange(e, 9);
                }}
                CropEnable={EnableCroping}
                resetzoom={ResetZoom}
              />
            </div>
          </div>
        </div>
        <div className="number-line-2">
          {/* <span>68"</span> */}
          {ShowCropIcon && !EnableCroping && <div className="d-flex justify-content-between mt-3">
               <button className="mx-5 btn btn-sm btn-secondary" onClick={()=>{setEnableCroping(true);setResetZoom(false)}}>Zoom <i class="fa fa-search" aria-hidden="true"></i> / Pan <i class="fa fa-crop pointer" aria-hidden="true"></i></button>
            {/* <label className="mx-5 pointer">Reset</label> */}
            </div>}
            {EnableCroping && 
            <div className="d-flex justify-content-between mt-3">
              <div>
            <label className="mx-5 fw-bold align-items-baseline d-flex"> Crop <h6 className="fw-normal text-muted ms-4">Scroll to zomm and Drag to pan</h6></label>
              </div>
              <div className="mx-5">
         <button className="me-3 btn-sm btn btn-outline-dark" onClick={()=>{setEnableCroping(false);setResetZoom(true)}} >Reset</button>
         <button className="btn btn-secondary btn-sm" onClick={()=>setEnableCroping(false)}>Apply</button>
              </div>
         </div>}
        </div>
      </div>
    </div>
  );
};

const Default = () => {
  return (
    <div className="frame-container">
      <img
        src="assets/img/blog/thumb.png"
        alt=""
        style={{ objectFit: "contain", maxWidth: "100%" }}
      />
    </div>
  );
};

export default function CustomImageBlocks({
  selectedSize,
  addToCartTriggered,
  sendAllSelectedImages,
  sendblobImage,
}) {
  const [SelectedSizeValue, setSelectedSizeValue] = useState("");
  const [AllSelectedImages, setAllSelectedImages] = useState("");

  // useEffect(() => {
  //   if (addToCartTriggered) {
  //     console.log('Add to cart triggered');
  //   }
  // }, [addToCartTriggered]);

  useEffect(() => {
    // console.log(selectedSize);
    setSelectedSizeValue(selectedSize);
  }, [selectedSize]);

  const updateAllSelectedImages = (images) => {
    sendAllSelectedImages(images);
    setAllSelectedImages(images);
    // console.log(images)
  };

  const SendBlobImage = (images) => {
    sendblobImage(images);
    // console.log(images)
  };

  return (
    <>
      {selectedSize?.size === "4-piece 34x24" ? (
        <Block1
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "4-piece 34x32" ? (
        <Block2
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "5-piece 48x40" ? (
        <Block3
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "5-piece 50x44" ? (
        <Block4
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "6-piece 56x44" ? (
        <Block5
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "6-piece 68x28" ? (
        <Block6
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "7-piece 38x30" ? (
        <Block7
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "7-piece 44x26" ? (
        <Block8
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "9-piece 26x26" ? (
        <Block9
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : selectedSize?.size === "10-piece 68x45" ? (
        <Block10
          updateAllSelectedImages={updateAllSelectedImages}
          sendBlobImage={SendBlobImage}
          addToCartTriggered={addToCartTriggered}
        />
      ) : (
        <Default />
      )}
    </>
  );
}
